import Vue3Katex from 'vue3-katex'

export default Vue3Katex
